import React, { FC } from 'react';
import { Spinner } from 'common/components/Spinner';

export const Loader: FC = () => {
  return (
    <div className="loader">
      <Spinner />
    </div>
  );
};
